import { ComponentProps } from 'react'
import { View, ViewProps, ViewStyle } from 'react-native'

import { DSColor, Palette } from '@ppwr/poker'

import { DSSpacing, Spacing } from './Spacing'

export interface FrameCompProps extends ViewProps {
  gap?: DSSpacing
  hidden?: boolean
  display?: ViewStyle['display']
  flex?: ViewStyle['flex']
  alignItems?: ViewStyle['alignItems']
  justifyContent?: ViewStyle['justifyContent']
  row?: boolean
  bg?: DSColor
}

export const Frame: React.FC<FrameCompProps> = ({
  gap,
  display,
  hidden,
  flex,
  alignItems,
  justifyContent,
  row,
  bg,
  style,
  ...props
}) => {
  if (hidden) {
    return null
  }
  return (
    <View
      style={[
        {
          gap: gap ? Spacing[gap] : 0,
          display,
          flex,
          flexDirection: row ? 'row' : undefined,
          alignItems,
          justifyContent,
          backgroundColor: bg && Palette[bg]
        },
        style
      ]}
      {...props}
    />
  )
}

export const Center = (props: ComponentProps<typeof Frame>) => (
  <Frame alignItems="center" justifyContent="center" {...props} />
)
